<app-partner-detail-header></app-partner-detail-header>
<app-partner-detail-nav-header></app-partner-detail-nav-header>
<app-partner-display-content></app-partner-display-content>